import { CASES } from './constants';

export const updateDealDROChanges = (payload) => {
    return { type: CASES.UPDATE_DEAL_DRO_CHANGES, payload };
};

export const updateDealDROChangesSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_DEAL_DRO_CHANGES_SEARCH_FORM,
        payload: { key, data },
    };
};

export const clearDealDROChanges = () => {
    return { type: CASES.CLEAR_DEAL_DRO_CHANGES, payload: {} };
};
